/*
 * Header component. This is special component to render form title
 * and description. Do not add this to the sidebar components.
 */
import React from 'react';

import Base from './base.jsx';
import {
  Mode,
} from '../common.jsx';
import Setting from "./setting.jsx";

import PdfAnchor from '../../common/pdf/PdfAnchor.jsx';

export default class Header extends Base {

        static get CATEGORY() {
            return 'other';
        }

        static get TYPE() {
            return 'form_header';
        }

        static get ANSWER_DEPENDENT() {
          return false;
        }

        static get TRANSLATED_ATTRIBUTES() {
            return {
                title: 'default_form_title',
                description: 'default_form_description'
            };
        }

        static defaultContent(language) {
            return Object.assign(super.defaultContent(language), {
                id: 'header',
                title: 'title',
                description: 'description',
                sortable: false,
                deletable: false
            });
        }

        render() {
            if (this.props.mode == Mode.TOOLBAR_ITEM) {
                return null;
            }
            return super.render();
        }

        renderView() {
            const [AnchorElement, anchorName] = PdfAnchor();

            let titleText = this.getText('title');
            let title = titleText.length > 0 ?
                titleText :
                (<em>[{I18n.t('default_form_title', {scope: 'fe'})}]</em>);
            return (
                <div>
                    <AnchorElement />
                    <h1 className='form-title' name={anchorName}>{title}</h1>
                    <p>{this.getText('description')}</p>
                </div>
            );
        }

        renderPrettyView() {
            return null;
        }

        renderSettings() {
            return (
                <div>
                    <Setting.TextField name="title" label={I18n.t('field_title', {scope: 'fe'})} value={this.getText('title')} onChange={this.updateSettings} />
                    <Setting.LongTextField name="description" label={I18n.t('field_description', {scope: 'fe'})} value={this.getText('description')} onChange={this.updateSettings} />
                </div>
            );
        }
}
